import axios from 'axios';

export const categories = () =>
  axios
    .post('/api/ds-category', { op: 'list' })
    .then(response => response.data)
    .catch(error => ({ success: false }));

export const createCategory = values =>
  axios
    .post('/api/ds-category', {
      op: 'create',
      item: values
    })
    .then(response => ({ data: response.data, success: true }))
    .catch(error => ({ success: false }));

export const getCategory = id =>
  axios
    .post('/api/ds-category', {
      op: 'read',
      convert: true,
      item: {
        id: id
      }
    })
    .then(response => response.data)
    .catch(error => ({ success: false }));

export const deleteCategory = id =>
  axios
    .post('/api/ds-category', { op: 'delete', item: { id } })
    .then(response => ({ data: response.data, success: true }))
    .catch(error => ({ success: false }));

export const updateCategory = (id, data) =>
  axios
    .post('/api/ds-category', { op: 'update', item: { id, ...data } })
    .then(response => ({ data: response.data, success: true }))
    .catch(error => ({ success: false }));

export const addAttributeToCategory = (categoryId, attributeId, flags) =>
  axios
    .post('/api/ds-category-attribute', {
      op: 'create',
      item: {
        categoryId,
        attributeId,
        flags
      }
    })
    .then(response => response.data)
    .catch(error => ({ success: false }));

export const removeAttributeToCategory = (categoryId, attributeId) =>
  axios
    .post('/api/ds-category-attribute', {
      op: 'delete',
      item: {
        categoryId,
        attributeId
      }
    })
    .then(response => response.data)
    .catch(error => ({ success: false }));



// WEBPACK FOOTER //
// ./src/modules/categories/_api.js